module.exports = __webpack_public_path__ + "img/yacht.b4a38aea.jpeg";